import { styled } from '@linaria/react';
import {
  layout,
  primitives,
  radius,
  semantic,
  shadow,
  size,
  space,
  textStyle,
} from '../../theme/tokens';

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  box-sizing: border-box;
  align-items: flex-start;
  gap: ${space['space-300']};
  padding: ${space['space-500']};
  border-radius: ${radius('notice', 'radius-md')};
  background: ${semantic.bg.canvas};
  box-shadow: ${shadow.xs};

  @media (hover: hover) and (min-width: ${layout.desktopBreakpoint}) {
    &:hover [data-dialog-dismiss] {
      opacity: 1;
    }
  }
`;

export const Content = styled.div`
  display: flex;
  flex: 1 0 0;
  min-width: 0;
  flex-direction: column;
  align-items: flex-start;
  gap: ${space['space-300']};

  @media (min-width: ${layout.desktopBreakpoint}) {
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    align-content: center;
    row-gap: ${space['space-300']};
    column-gap: ${space['space-500']};
  }
`;

export const CtaSlot = styled.div`
  flex-shrink: 0;
`;

export const Copy = styled.div`
  display: flex;
  flex: 1 0 0;
  min-width: 0;
  align-items: flex-start;
  gap: ${space['space-500']};
`;

export const ToneBar = styled.span`
  align-self: stretch;
  flex-shrink: 0;
  width: ${primitives.size['size-200']};
  border-radius: ${size.radius['radius-full']};

  &[data-tone='positive'] {
    background: ${semantic.bg.positiveStrong};
  }

  &[data-tone='info'] {
    background: ${semantic.bg.infoStrong};
  }

  &[data-tone='warning'] {
    background: ${semantic.bg.warningStrong};
  }

  &[data-tone='danger'] {
    background: ${semantic.bg.dangerStrong};
  }
`;

export const Text = styled.div`
  display: flex;
  flex: 1 0 0;
  min-width: 0;
  flex-direction: column;
  gap: ${space['space-050']};
`;

export const Title = styled.p`
  margin: 0;
  font-family: ${textStyle.body.md.strong.fontFamily};
  font-size: ${textStyle.body.md.strong.fontSize};
  font-weight: ${textStyle.body.md.strong.fontWeight};
  line-height: ${textStyle.body.md.strong.lineHeight};
  letter-spacing: ${textStyle.body.md.strong.letterSpacing};
  color: ${semantic.text.primary};
  overflow-wrap: break-word;
`;

export const Subtitle = styled.div`
  font-family: ${textStyle.body.sm.regular.fontFamily};
  font-size: ${textStyle.body.sm.regular.fontSize};
  font-weight: ${textStyle.body.sm.regular.fontWeight};
  line-height: ${textStyle.body.sm.regular.lineHeight};
  letter-spacing: ${textStyle.body.sm.regular.letterSpacing};
  color: ${semantic.text.secondary};
  overflow-wrap: break-word;
`;

export const DismissButton = styled.button`
  position: absolute;
  top: calc(-1 * ${space['space-300']});
  right: calc(-1 * ${space['space-200']});
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${primitives.size['size-800']};
  height: ${primitives.size['size-800']};
  padding: 0;
  border: none;
  border-radius: ${radius('button', 'radius-full')};
  background: ${semantic.bg.secondary};
  box-shadow: ${shadow.xs};
  color: ${semantic.text.primary};
  cursor: pointer;

  &:focus-visible {
    outline: ${size.stroke['stroke-thick']} solid ${semantic.border.selected};
    outline-offset: ${space['space-050']};
  }

  @media (min-width: ${layout.desktopBreakpoint}) {
    right: auto;
    left: calc(-1 * ${space['space-400']});
  }

  @media (hover: hover) and (min-width: ${layout.desktopBreakpoint}) {
    opacity: 0;

    &:focus-visible {
      opacity: 1;
    }
  }
`;
